export const mobileWidth = 1021;

export const customWidth=750;

export const customView=`@media (max-width: 750px)`;

export const mobileView = `@media (max-width: 1021px)`;